import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import useOpenState from '../../../../../hooks/useOpenState';
import MessageBox from '../../../../../util/messageBox';
import { Typography } from '@mui/material';
import MedicineAutocomplete from './inputs/medicineAutocomplete';
import { useEffect, useState } from 'react';
import MedicineDetailsContainer from './inputs/medicineDetailsContainer';
import MedicineSelectedBox from './inputs/medicineSelectedBox';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'start',
        justifyContent: 'stretch',
        gap: 5,
        width: '100%',
        minHeight: 71,
    },
    button: {
        height: '56px !important',
        minWidth: 100,
    },
}));

const DrugSelectorComponent = ({ value, handleChange, disabled, error = false }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [mainMedicine, setMainMedicine] = useState(null);
    const [medicine, setMedicine] = useState(null);

    const handleChangeMedicine = () => {
        closeModal();
        setMainMedicine(null);
        setMedicine(null);
    };

    useEffect(() => {
        if (value) {
            setMainMedicine(value.vmp);
        }
    }, [value]);

    useEffect(() => {
        // Prevent changes if form is disabled
        if (disabled) return;

        handleChange((prev) => ({
            ...prev,
            vmp: mainMedicine,
            amp: null,
            ampp: null,
        }));
    }, [mainMedicine, disabled]);

    return (
        <>
            <Typography fontSize={16} fontWeight={500} sx={{ ml: 1 }}>
                {t('Drug Prescribed')} *
            </Typography>

            <div className={classes.root}>
                {!mainMedicine ? (
                    <MedicineAutocomplete value={mainMedicine} handleChangeValue={setMainMedicine} disabled={disabled} error={error} />
                ) : (
                    <MedicineSelectedBox medicine={mainMedicine} onChange={openModal} type="VMP" disabled={disabled} />
                )}
            </div>

            <MedicineDetailsContainer
                value={value}
                handleChange={setMedicine}
                mainMedicine={mainMedicine}
                handleChangeMainForm={handleChange}
                disabled={disabled}
            />

            <MessageBox
                onClose={closeModal}
                title={t('Confirmation')}
                haveAccept={{ yes: t('Submit'), no: t('Close') }}
                onAccept={handleChangeMedicine}
                message={t('Are you sure you want to change the selected drug? This will clear all form fields.')}
                open={isModalOpen}
            />
        </>
    );
};

export default DrugSelectorComponent;
